'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Burger = exports.Diamond = exports.Square = exports.Triangle = exports.Arrow = exports.Chevron = exports.Minus = exports.Plus = exports.X = exports.createShapes = exports.Icon = exports.Line = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Line = require('./Line');

Object.defineProperty(exports, 'Line', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Line).default;
  }
});

var _Icon = require('./Icon');

Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

var _createShapes = require('./create-shapes');

Object.defineProperty(exports, 'createShapes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createShapes).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Line2 = _interopRequireDefault(_Line);

var _Icon2 = _interopRequireDefault(_Icon);

var _createShapes2 = _interopRequireDefault(_createShapes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X = exports.X = function X(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'x' }));
};
var Plus = exports.Plus = function Plus(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'plus' }));
};
var Minus = exports.Minus = function Minus(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'minus' }));
};
var Chevron = exports.Chevron = function Chevron(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'chevron' }));
};
var Arrow = exports.Arrow = function Arrow(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'arrow' }));
};
var Triangle = exports.Triangle = function Triangle(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'triangle' }));
};
var Square = exports.Square = function Square(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'square' }));
};
var Diamond = exports.Diamond = function Diamond(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'diamond' }));
};
var Burger = exports.Burger = function Burger(props) {
  return _react2.default.createElement(_Icon2.default, _extends({}, props, { name: 'burger' }));
};

exports.default = {
  Line: _Line2.default,
  Icon: _Icon2.default,
  createShapes: _createShapes2.default,
  X: X,
  Plus: Plus,
  Minus: Minus,
  Square: Square,
  Diamond: Diamond,
  Burger: Burger,
  Chevron: Chevron,
  Arrow: Arrow,
  Triangle: Triangle
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reline/dist/index.js
 ** module id = 72
 ** module chunks = 0
 **/